import { getEnv } from "@istari-frontend/shared";

const BANNER_HEIGHT = 32;
const ITAR_BANNER_TEXT = "CUI data allowed; ITAR data allowed";
const ITAR_BANNER_COLOR = "#723D9A";

type ItarBannerData = {
  enabled: boolean;
  bannerOffset: number;
};

interface ItarBannerProps {
  topOffset?: number;
}

export function ItarBanner({ topOffset = 0 }: ItarBannerProps) {
  const { enabled } = useItarBannerData();

  if (!enabled) {
    return null;
  }

  return (
    <div
      className="bg-background fixed right-0 left-0 z-50 p-1"
      style={{
        height: `${BANNER_HEIGHT}px`,
        top: `${topOffset}px`,
      }}
      role="banner"
    >
      <div
        className="flex h-full items-center justify-center rounded-sm px-3"
        style={{ backgroundColor: ITAR_BANNER_COLOR }}
      >
        <span className="font-mono text-sm text-white drop-shadow-sm">{ITAR_BANNER_TEXT}</span>
      </div>
    </div>
  );
}

export function useItarBannerData(): ItarBannerData {
  const enabled = getEnv("VITE_ITAR") === "true";
  const bannerOffset = enabled ? BANNER_HEIGHT : 0;

  return { enabled, bannerOffset };
}

export function getItarBannerHeight(enabled: boolean): number {
  return enabled ? BANNER_HEIGHT : 0;
}
